<section
  class="offering-hero bg-blue-gradient-bottom-right"
  aria-labelledby="offering-hero-title"
>
  <div class="offering-hero-content">
    <div class="offering-hero-description">
      <rds-badge
        size="m"
        [label]="approvalStatus()"
        type="minimal"
        color="green"
      ></rds-badge>
      <h1 id="offering-hero-title" class="ui-heading-1-bold">
        {{ displayName() }}
      </h1>
      <p class="ui-body-l">{{ description() }}</p>

      <div class="buttons">
        @if (callToAction()) {
          <button
            rds-primary-button
            size="l"
            attr.aria-label="Get started"
            faroAction="offering hero get started"
            (click)="navigate()"
          >
            Get started
          </button>
        }
        <button
          rds-secondary-button
          size="l"
          attr.aria-label="Learn more"
          (click)="scrollTo('Offering details')"
        >
          Learn more
        </button>
      </div>

      <div class="caption">
        @if (licenseCostResponsibility()) {
          <div class="licence">
            <span class="ui-label-m-bold me-2"
              >License cost responsibility:</span
            >
            <span class="ui-body-m">{{ licenseCostResponsibility() }}</span>
          </div>
        }
        @if (successor()) {
          <div class="successor no-wrap">
            <span class="ui-label-m me-2">Successor:</span>
            <a
              rds-link
              [routerLink]="['/offerings', successor()?.slug]"
              [attr.aria-label]="'Go to ' + successor()?.content?.displayName"
              >{{ successor()?.content?.displayName }}</a
            >
          </div>
        }
        @if (relationshipTarget() && relationshipType()) {
          <div class="relationship no-wrap">
            <span class="ui-label-m me-2">{{
              relationshipType() === "Child of" ? "Child of:" : "Parent of:"
            }}</span>
            <a
              rds-link
              [routerLink]="['/offerings', relationshipTarget()?.slug]"
              [attr.aria-label]="
                'Go to ' + relationshipTarget()?.content?.displayName
              "
              >{{ relationshipTarget()?.content?.displayName }}</a
            >
          </div>
        }
      </div>

      @if (tags().length > 0) {
        <div class="tags">
          @for (tag of tags(); track $index) {
            @if (tag.length > 0) {
              <rds-badge
                size="m"
                label="{{ tag }}"
                type="minimal"
                color="blue"
              ></rds-badge>
            }
          }
        </div>
      }

      <!-- Last in the hero, on a row of its own: the factsheet is what you take
           away, so it stays out of the row carrying "Get started" and "Learn
           more" rather than becoming a third call to action. The row exists
           only when there is something to download — see `canDownloadFactsheet`
           — because an empty one would hold the column's 20px gap open. -->
      <ng-container *inexpFeatureFlag="'panorama_inexp_2446_offering_markdown'">
        @if (canDownloadFactsheet()) {
          <div class="factsheet">
            <inexp-offering-download [offering]="offering()" />
          </div>
        }
      </ng-container>
    </div>
  </div>
</section>
